<template>

    <header class="header" :class="{'transparent': $route.name !== 'story'}">

        <div class="container-fluid">

            <div class="header-inner">
                <a :href="this.$i18n.locale == 'en' ? '/en' : this.$i18n.locale == 'fr' ? '/fr' : '/bcs'" class="header-logo" target="_blank">

                    <img v-if="this.$i18n.locale == 'en'" :src="publicPath+'images/irmct-logo.png'" alt="Irmct logo">

                    <img v-else-if="this.$i18n.locale == 'fr'" :src="publicPath+'images/irmct_logo_comms_acronym.png'" alt="Irmct logo">

                    <img v-else :src="publicPath+'images/mrmks-logo.png'" alt="Mrmks logo">

                </a>

                <div class="header-action" v-if="$route.name === 'story'">
                    <p class="header-action-text">{{ $t('nav.toggle-bar.label') }}</p>

                    <label class="header-action-label first" :class="{'active' : getViewPerspective == 'perspective-first'}" for="perspective-first">{{ $t('nav.toggle-bar.first-perspective-label') }}</label>

                    <div class="header-action-toggle" :class="{'active' : getViewPerspective !== 'perspective-default'}">

                        <label class="first" :class="{'active' : getViewPerspective == 'perspective-first'}">
                            <input class="special" @click="setViewPerspective('perspective-first')" id="perspective-first" name="perspective-view" type="radio" />

                            <span class="icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="3.518" height="5.422" viewBox="0 0 3.518 5.422"><g id="Group_211" data-name="Group 211" transform="translate(-187.496 -6)"><g id="Group_210" data-name="Group 210" transform="translate(378.511 17.422) rotate(180)"><g id="_7" data-name=" 7" transform="translate(191.015 6) rotate(90)" opacity="0.9"><path id="Path_36" data-name="Path 36" d="M2.711,0,0,2.711l.807.807,1.9-1.9,1.9,1.9.807-.807Z" transform="translate(0 0)" fill="#fff"/></g></g></g></svg>
                            </span>

                            <span class="icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="3.518" height="5.422" viewBox="0 0 3.518 5.422"><g id="Group_211" data-name="Group 211" transform="translate(-187.496 -6)"><g id="Group_210" data-name="Group 210" transform="translate(378.511 17.422) rotate(180)"><g id="_7" data-name=" 7" transform="translate(191.015 6) rotate(90)" opacity="0.9"><path id="Path_36" data-name="Path 36" d="M2.711,0,0,2.711l.807.807,1.9-1.9,1.9,1.9.807-.807Z" transform="translate(0 0)" fill="#fff"/></g></g></g></svg>
                            </span>

                        </label>

                        <label class="helper">
                            <input class="default" @click="setViewPerspective('perspective-default')" id="perspective-default" name="perspective-view" type="radio" checked="checked" />
                        </label>

                        <label class="second" :class="{'active' : getViewPerspective == 'perspective-second'}">
                            <input class="special" @click="setViewPerspective('perspective-second')" id="perspective-second" name="perspective-view" type="radio" />

                            <span class="icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="3.518" height="5.422" viewBox="0 0 3.518 5.422"><g id="Group_210" data-name="Group 210" transform="translate(-187.496 -6)"><g id="_7" data-name=" 7" transform="translate(191.015 6) rotate(90)" opacity="0.9"><path id="Path_36" data-name="Path 36" d="M2.711,0,0,2.711l.807.807,1.9-1.9,1.9,1.9.807-.807Z" transform="translate(0 0)" fill="#fff"/></g></g></svg>
                            </span>

                            <span class="icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="3.518" height="5.422" viewBox="0 0 3.518 5.422"><g id="Group_210" data-name="Group 210" transform="translate(-187.496 -6)"><g id="_7" data-name=" 7" transform="translate(191.015 6) rotate(90)" opacity="0.9"><path id="Path_36" data-name="Path 36" d="M2.711,0,0,2.711l.807.807,1.9-1.9,1.9,1.9.807-.807Z" transform="translate(0 0)" fill="#fff"/></g></g></svg>
                            </span>

                        </label>
                    </div>


                    <label class="header-action-label last" :class="{'active' : getViewPerspective == 'perspective-second'}" for="perspective-second">{{ $t('nav.toggle-bar.second-perspective-label') }}</label>

                </div>

                <a href="#" @click.prevent="mapModalOpen" class="header-map" v-if="$route.name === 'story'">

                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16"><defs><clipPath id="clip-path"><rect width="16" height="16" fill="none"/></clipPath></defs><g id="Web" clip-path="url(#clip-path)"><path id="Path_4" data-name="Path 4" d="M2.4,2.4A7.263,7.263,0,0,1,8,0a7.263,7.263,0,0,1,5.6,2.4A7.263,7.263,0,0,1,16,8a7.263,7.263,0,0,1-2.4,5.6A7.263,7.263,0,0,1,8,16a7.263,7.263,0,0,1-5.6-2.4A7.984,7.984,0,0,1,0,8,7.263,7.263,0,0,1,2.4,2.4Zm6.667,12a3.276,3.276,0,0,0,2-1.2A5.824,5.824,0,0,0,12,10.4a2.208,2.208,0,0,0-.667-1.6A2.347,2.347,0,0,0,9.6,8H8.267a3.893,3.893,0,0,1-1.2-.267,1.21,1.21,0,0,1-.4-.933.693.693,0,0,1,.267-.533A1.011,1.011,0,0,1,7.467,6a.91.91,0,0,1,.667.4c.267.133.4.267.533.267A.8.8,0,0,0,9.2,6.533.8.8,0,0,0,9.333,6a2.122,2.122,0,0,0-.667-1.333,5.515,5.515,0,0,0,.667-2.533.287.287,0,0,0-.267-.267A4.122,4.122,0,0,0,8,1.6,6.67,6.67,0,0,0,4.533,2.667a3.357,3.357,0,0,0-1.2,2.667A3.414,3.414,0,0,0,4.4,7.867,3.643,3.643,0,0,0,6.933,8.933h0v.533A1.712,1.712,0,0,0,7.467,10.8a1.942,1.942,0,0,0,1.2.8V14c0,.133,0,.133.133.267S8.933,14.4,9.067,14.4Z" fill="#fff"/></g></svg>

                </a>


                <div class="header-side">

                    <div class="header-lang">
                        <span class="header-lang-label">
                            {{ this.$root.$i18n.locale }}

                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="9.4" height="6.1" viewBox="0 0 9.4 6.1"><defs><clipPath id="clip-path"><rect width="9.4" height="6.1" fill="none"/></clipPath></defs><g id="Down_arrow_small" data-name="Down arrow small" clip-path="url(#clip-path)"><path id="Path_36" data-name="Path 36" d="M6.7,8.1,2,3.4,3.4,2,6.7,5.3,10,2l1.4,1.4Z" transform="translate(-2 -2)" fill="#fff"/></g></svg>
                        </span>

                        <ul class="header-lang-list">
                            <li v-for="locale in locales" :key="locale" @click="switchLocale(locale)">
                                {{locale}}
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="header-action-mobile" v-if="$route.name === 'story'">

                    <div class="header-action-toggle" :class="{'active' : getViewPerspective !== 'perspective-default'}">

                        <span class="icon">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="9.4" height="6.1" viewBox="0 0 9.4 6.1"><defs><clipPath id="clip-path"><rect width="9.4" height="6.1" fill="none"/></clipPath></defs><g id="Down_arrow_small" data-name="Down arrow small" clip-path="url(#clip-path)"><path id="Path_36" data-name="Path 36" d="M6.7,8.1,2,3.4,3.4,2,6.7,5.3,10,2l1.4,1.4Z" transform="translate(-2 -2)" fill="#fff"/></g></svg>
                        </span>

                        <label :class="{'active' : getViewPerspective == 'perspective-first', 'order': dropdownSelected == 'first'}">
                            {{ $t('nav.toggle-bar.first-perspective-label') }}

                            <input class="special" @click="setViewPerspective('perspective-first'), activePerspective('first')" id="perspective-first" name="perspective-view" type="radio" />

                        </label>

                        <label :class="{'active' : getViewPerspective == 'perspective-second', 'order': dropdownSelected == 'second'}">
                            {{ $t('nav.toggle-bar.second-perspective-label') }}

                            <input class="special" @click="setViewPerspective('perspective-second'), activePerspective('second')" id="perspective-second" name="perspective-view" type="radio" />

                        </label>
                    </div>
                </div>
            </div>

        </div>

    </header>

</template>

<script>
// import i18n from '@/i18n'

export default {
  name: 'Header',

  data () {
    return {
      locales: process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(','),
      dropdownSelected: 'first',
      publicPath: process.env.BASE_URL
    }
  },
  computed: {
    getViewPerspective () {
      return this.$store.getters.getterViewPerspectiveValue
    }
  },
  mounted() {
    window.addEventListener('load', () => {
      if (window.innerWidth < 768) {
        this.mobileDevice = true
        this.$store.dispatch('updateViewPerspectiveValue', 'perspective-first');
      }
    })
  },
  methods: {
    switchLocale(locale) {
      if (this.$i18n.locale !== locale) {
        this.$i18n.locale = locale;
        const to = this.$router.resolve({ params: {locale} })
        this.$router.push(to.location)
        document.querySelector('html').setAttribute('lang', locale)
      }
    },
    setViewPerspective (perspective) {
      this.$store.dispatch('updateViewPerspectiveValue', perspective)
    },
    mapModalOpen () {
      this.$store.dispatch('updateMapModalState', true)
    },
    activePerspective (selected) {
      this.dropdownSelected = selected
    }
  }
}
</script>

